module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e03-907bdab1e59b6f4c6fd2b45b0b924195.jpg";